import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

interface HeroProps {
  title: string;
  subtitle: string;
  ctaText?: string;
  ctaLink?: string;
  secondaryCtaText?: string;
  secondaryCtaLink?: string;
  image?: string;
}

const Hero = ({
  title,
  subtitle,
  ctaText,
  ctaLink,
  secondaryCtaText,
  secondaryCtaLink,
  image = "/images/ryeland4.jpg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
}: HeroProps) => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-neutral-100 to-white">
      <div className="absolute inset-0 z-0">
        <div 
          className="absolute inset-0 bg-gradient-to-r from-primary/90 to-primary-dark/80 mix-blend-multiply"
          style={{
            backgroundImage: `url(${image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        ></div>
      </div>
      
      <div className="container relative z-10 mx-auto px-4 py-20 md:py-32">
        <div className="max-w-3xl text-white">
          <motion.h1 
            className="font-sans text-4xl md:text-5xl lg:text-6xl font-bold mb-6"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            {title}
          </motion.h1>
          
          <motion.p 
            className="text-lg md:text-xl mb-8 text-neutral-100"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            {subtitle}
          </motion.p>
          
          <motion.div 
            className="flex flex-wrap gap-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            {ctaText && ctaLink && (
              <a 
                href={ctaLink} 
                className="btn bg-white text-primary-dark hover:bg-neutral-100 inline-flex items-center gap-2"
                target="_blank"
                rel="noopener noreferrer"
              >
                {ctaText}
                <ArrowRight size={18} />
              </a>
            )}
            
            {secondaryCtaText && secondaryCtaLink && (
              <a 
                href={secondaryCtaLink} 
                className="btn border-2 border-white text-white hover:bg-white/10"
              >
                {secondaryCtaText}
              </a>
            )}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;